module.exports = __webpack_public_path__ + "static-portal/img/news10-1.c1e0a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news10-1.jpg
// module id = 5uFG
// module chunks = 4